(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './pull'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./pull'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pull);
    global.without = mod.exports;
  }
})(this, function (exports, _pull) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.without = undefined;


  /**
   * This method is an alias of {@link array.pull}.
   * @function
   * @memberof array
   * @since 0.3.0
   */
  var without = _pull.pull;

  exports.without = without;
  exports.default = without;
});